import { EntryCollection } from 'contentful';

import { IAboutFields } from '../../../@types/generated/contentful';
import { useContentfulFetchers } from '../../context/ContentfulContext';
import { useAsyncContentfulQuery } from './useAsyncContentfulQuery';

export function useAboutQuery() {
  const { fetchAbout } = useContentfulFetchers();
  return useAsyncContentfulQuery<EntryCollection<IAboutFields>>(() => fetchAbout(), [fetchAbout]);
}
